import { render } from "./VotingComponent.vue?vue&type=template&id=59ff2b4c"
import script from "./VotingComponent.vue?vue&type=script&lang=js"
export * from "./VotingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__